export const DEFAULT_MENU_ITEM_IMAGE = 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?q=80&w=800&auto=format&fit=crop';

/**
 * Служебный домен для логинов сотрудников. Firebase Auth требует email,
 * а персонал входит по короткому логину — поэтому `login` → `login@домен`.
 * ДОЛЖЕН совпадать со STAFF_EMAIL_DOMAIN на сервере (server.ts), иначе
 * созданный в админке аккаунт не сможет войти.
 */
export const STAFF_EMAIL_DOMAIN = 'example.com';
